import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const operationsPlanService = {
  getPlans,
  getDashboard,
  createPlan,
  updatePlan,
  deletePlan,
  getItems,
  createItem,
  createItemsBulk,
  updateItem,
  updateSeries,
  deleteItem,
};

function getPlans(propertyId) {
  return axios
    .get(`${apiEndpoint.operationsPlans}?property_id=${propertyId}`, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return { plans: [] };
    });
}

function getDashboard(planId) {
  return axios
    .get(`${apiEndpoint.operationsPlanDashboard}?plan_id=${planId}`, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return null;
    });
}

function createPlan(data) {
  return axios
    .post(apiEndpoint.operationsPlans, data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function updatePlan(id, data) {
  return axios
    .put(apiEndpointFunction.operationsPlans(id), data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function deletePlan(id) {
  return axios
    .delete(apiEndpointFunction.operationsPlans(id), { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function getItems(planId) {
  return axios
    .get(`${apiEndpoint.operationsPlanItems}?plan_id=${planId}`, {
      headers: authHeader(),
    })
    .then((res) => {
      if (res && res.status === 200 && res.data.code === '0000') {
        return res.data;
      }
      return { items: [] };
    });
}

function createItem(data) {
  return axios
    .post(apiEndpoint.operationsPlanItems, data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

// Create a recurring series of plan items in one request. `data.dates` holds the
// occurrence dates (computed client-side); the rest is the shared item payload.
function createItemsBulk(data) {
  return axios
    .post(`${apiEndpoint.operationsPlanItems}/bulk`, data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function updateItem(id, data) {
  return axios
    .put(apiEndpointFunction.operationsPlanItems(id), data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

// Edit a repeating series: sync shared fields across all occurrences and
// regenerate the upcoming ones to the (possibly changed) cadence. `data.dates`
// is the full new-cadence occurrence list. Returns { series_id, created }.
function updateSeries(id, data) {
  return axios
    .post(`${apiEndpointFunction.operationsPlanItems(id)}/update-series`, data, { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}

function deleteItem(id) {
  return axios
    .delete(apiEndpointFunction.operationsPlanItems(id), { headers: authHeader() })
    .then((res) => (res && res.status === 200 ? res.data : {}));
}
